import {i18n} from 'mc/lib';
import {combineDateTime, formatDate, formatTime, localUTCToDate, localUTCToTime} from 'mc/lib/utils/commons';
import PropTypes from 'prop-types';

/**
 * Typ property období.
 */
export const obdobiPropType = PropTypes.shape({
    datumPocatek: PropTypes.string,
    datumKonec: PropTypes.string,
    casPocatek: PropTypes.string,
    casKonec: PropTypes.string,
    upresneni: PropTypes.string,
});

/**
 * Naformátuje období na řetězec.
 *
 * @param obdobi - období
 * @returns {string} řetězec
 */
export function formatObdobi(obdobi) {
    const datumPocatek = localUTCToDate(obdobi.datumPocatek);
    const datumKonec = localUTCToDate(obdobi.datumKonec);

    const casPocatek = localUTCToTime(obdobi.casPocatek);
    const casKonec = localUTCToTime(obdobi.casKonec);

    if (casPocatek == null && casKonec == null) {
        if (datumPocatek.getTime() === datumKonec.getTime()) {
            return formatDate(datumPocatek);
        }
        return formatDate(datumPocatek) + ' - ' + formatDate(datumKonec);
    }

    if (datumPocatek.getTime() === datumKonec.getTime()) {
        return formatDate(datumPocatek) + ' ' + formatTime(casPocatek) + ' - ' + formatTime(casKonec)
    }

    return formatDate(datumPocatek) + ' ' + formatTime(casPocatek)
        + ' - ' + formatDate(datumKonec) + ' ' + formatTime(casKonec);
}

/**
 * Zvaliduje období.
 *
 * @param obdobi období
 * @returns {string} chybová hláška nebo null pokud je období validní
 */
export function validateObdobi(obdobi) {
    const datumPocatek = localUTCToDate(obdobi.datumPocatek);
    const datumKonec = localUTCToDate(obdobi.datumKonec);

    if (!datumPocatek || !datumKonec) {
        return i18n('obdobi.missingDate');
    }

    const casPocatek = localUTCToTime(obdobi.casPocatek);
    const casKonec = localUTCToTime(obdobi.casKonec);

    if ((casPocatek != null) !== (casKonec != null)) {
        return i18n('obdobi.missingOneOfTimes');
    }

    const datumCasPocatek = combineDateTime(datumPocatek, casPocatek);
    if (datumCasPocatek <= new Date()) {
        return i18n('obdobi.dateTimFromPast');
    }

    const datumCasKonec = combineDateTime(datumKonec, casKonec);
    const timeDiff = datumCasKonec.getTime() - datumCasPocatek.getTime();

    if (casPocatek && casKonec) {
        if (timeDiff === 0) {
            return i18n('obdobi.sameStartEndDateTime');
        }
        if (timeDiff < 0) {
            return i18n('obdobi.endBeforeStartDateTime');
        }
    } else if (timeDiff < 0) {
        return i18n('obdobi.endBeforeStartDate');
    }

    return null;
}

export function validateObdobiList(obdobiList) {
    return obdobiList.map(validateObdobi);
}

export function validateObdobiListAsSingleValue(obdobiList) {
    if (obdobiList.length > 0) {
        return validateObdobiList(obdobiList).filter(Boolean)[0];
    }
    return i18n('obdobi.missingDate');
}
